import { DRAW_STRUCTURE_SET_EDITOR_TYPE, DRAW_STRUCTURE_SET_LOADING } from '@Pages/RetroSynthesis/DrawStructure/constants';

export const setEditorType = (editorType) => ({
  type: DRAW_STRUCTURE_SET_EDITOR_TYPE,
  payload: { editorType },
});

export const setLoading = (isLoading) => ({
  type: DRAW_STRUCTURE_SET_LOADING,
  payload: { isLoading },
});
